import { idtype } from "querypieces";

export default `
  ...on articleBuilder_text_BlockType {
    ${idtype}
    richText
  }
`;
